"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTypeOverrides = exports.executeQuery = void 0;
var executeQuery_1 = require("./executeQuery");
Object.defineProperty(exports, "executeQuery", { enumerable: true, get: function () { return executeQuery_1.executeQuery; } });
var createTypeOverrides_1 = require("./createTypeOverrides");
Object.defineProperty(exports, "createTypeOverrides", { enumerable: true, get: function () { return createTypeOverrides_1.createTypeOverrides; } });
